import { useEffect, useRef, useState } from "react";

export const useAutoToggleOpen = ({
    wrapId,
}: {
    wrapId: string;
}) => {
    // 뷰포트 기준 70%에 해당 컴포넌트가 보이면 block의 첫번째 토글 자동 오픈
    const [firstOpen, setFirstOpen] = useState(false);
    // throttle + requestAnimationFrame 직접 구현
    let ticking = false;
    const lastRan = useRef(0);
    const throttleDelay = 200; // ms
    const handleScroll = () => {

        if (!ticking) {
            window.requestAnimationFrame(() => {
                const now = Date.now();
                if (now - lastRan.current > throttleDelay) {
                    const block = document.querySelector(
                        `#${wrapId}`
                    );
                    if (block) {
                        const blockRect = block.getBoundingClientRect();
                        if (blockRect.top <= window.innerHeight * 0.7) {
                            setFirstOpen(true);
                        }
                    }
                    lastRan.current = now;
                }
                ticking = false;
            });
            ticking = true;
        }
    };
    useEffect(() => {
        if (!wrapId) return;
        if (firstOpen) {
            window.removeEventListener("scroll", handleScroll);
            return;
        } // 이미 열렸으면 리스너 등록 X

        window.addEventListener("scroll", handleScroll);
        // mount 시에도 한 번 체크
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [firstOpen, wrapId]);
    return firstOpen;
};
